import React, { Component, Fragment } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { getOrgs } from "../actions/orgsActions";

import PropTypes from "prop-types";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import { CSVLink } from "react-csv";
import OrgDetails from "./OrgDetails";
import OrgDetailsAdmin from "./OrgDetailsAdmin";
import AddNew from "./AddNew";

import { Button, Modal, ModalBody, Form, FormGroup } from "reactstrap";

export class OrgsList extends Component {
  state = {
    orgName: [],
    modal: false,
    modalAddNew: false,
    headers: [
      { label: "AutoID", key: "AutoID" },
      { label: "Name", key: "Name" },
      { label: "ChapterName", key: "ChapterName" },
      { label: "Type", key: "Type" },
      { label: "URL", key: "URL" },
      { label: "Email", key: "Email" },
      { label: "AdvisorName", key: "AdvisorName" },
      { label: "AdvisorEmail", key: "AdvisorEmail" },
      { label: "AdvisorPhone", key: "AdvisorPhone" },
      { label: "StudentContact", key: "StudentContact" },
      { label: "StudentEmail", key: "StudentEmail" },
      { label: "StudentPhone", key: "StudentPhone" },
      { label: "FinancialManagerName", key: "FinancialManagerName" },
      { label: "FinancialManagerEmail", key: "FinancialManagerEmail" },
      { label: "FinancialManagerPhone", key: "FinancialManagerPhone" },
      { label: "RosterManagerName", key: "RosterManagerName" },
      { label: "RosterManagerEmail", key: "RosterManagerEmail" },
      { label: "RosterManagerPhone", key: "RosterManagerPhone" },
      { label: "Size", key: "Size" },
      { label: "Standing", key: "Standing" },
      { label: "Constitution", key: "Constitution" },
      { label: "Charter", key: "Charter" },
      { label: "KirkContract", key: "KirkContract" },
      { label: "Description", key: "Description" },
      { label: "Comments", key: "Comments" },
      { label: "Keywords", key: "Keywords" },
      { label: "RiskMgtName", key: "RiskMgtName" },
      { label: "RiskMgtEmail", key: "RiskMgtEmail" },
      { label: "RiskMgtPhone", key: "RiskMgtPhone" },
      { label: "RiskMgtDone", key: "RiskMgtDone" },
    ],
    data: [],
    addNewId: "",
  };

  componentDidMount() {
    this.props.getOrgs();
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };

  toggleAddNew = (e) => {
    this.setState({
      modalAddNew: !this.state.modalAddNew,
      addNewId: e.target.id,
    });
  };

  toggleAddNewClose = (e) => {
    this.setState({
      modalAddNew: !this.state.modalAddNew,
    });
  };

  getInfos = async () => {
    let res = await axios.get(`api/orgs/info`);
    return res.data;
  };

  getWorkshops = async () => {
    let res = await axios.get(`api/orgs/workshop`);
    return res.data;
  };

  getRosters = async () => {
    let res = await axios.get(`api/orgs/roster`);
    return res.data;
  };

  getRenewals = async () => {
    let res = await axios.get(`api/orgs/renewal`);
    return res.data;
  };

  getRiskmgts = async () => {
    let res = await axios.get(`api/orgs/riskmgt`);
    return res.data;
  };

  getRiskmgt2s = async () => {
    let res = await axios.get(`api/orgs/riskmgt2`);
    return res.data;
  };

  getAdvisors = async () => {
    let res = await axios.get(`api/orgs/advisor`);
    return res.data;
  };

  getFinancialRisks = async () => {
    let res = await axios.get(`api/orgs/financialRisk`);
    return res.data;
  };
  //------------------------------------------------------------
  getInfo = async (AutoID) => {
    let res = await axios.get(`api/orgs/info/${AutoID}`);
    return res.data;
  };

  getWorkshop = async (AutoID) => {
    let res = await axios.get(`api/orgs/workshop/${AutoID}`);
    return res.data;
  };

  getRoster = async (AutoID) => {
    let res = await axios.get(`api/orgs/roster/${AutoID}`);
    return res.data;
  };

  getRenewal = async (AutoID) => {
    let res = await axios.get(`api/orgs/renewal/${AutoID}`);
    return res.data;
  };

  getRiskmgt = async (AutoID) => {
    let res = await axios.get(`api/orgs/riskmgt/${AutoID}`);
    return res.data;
  };

  getRiskmgt2 = async (AutoID) => {
    let res = await axios.get(`api/orgs/riskmgt2/${AutoID}`);
    return res.data;
  };

  getAdvisor = async (AutoID) => {
    let res = await axios.get(`api/orgs/advisor/${AutoID}`);
    return res.data;
  };

  getFinancialRisk = async (AutoID) => {
    let res = await axios.get(`api/orgs/financialRisk/${AutoID}`);
    return res.data;
  };

  fetchOrgsData = async () => {
    const infos = await this.getInfos();
    const rosters = await this.getRosters();
    const renewals = await this.getRenewals();
    const workshops = await this.getWorkshops();
    const riskmgts = await this.getRiskmgts();
    const riskmgts2 = await this.getRiskmgt2s();
    const advisors = await this.getAdvisors();
    const financialRisks = await this.getFinancialRisks();
    return {
      infos,
      rosters,
      renewals,
      workshops,
      riskmgts,
      riskmgts2,
      advisors,
      financialRisks
    };
  };

  handleExport = () => {
    this.fetchOrgsData().then((data) => {
      let newHeaders = [
        ...this.state.headers,
        ...this.getExport(data).concat(this.getExport2(data)),
      ];
      this.setState({ data: data, headers: newHeaders }, () => {
        console.log("exporting");
        this.csvLink.link.click();
      });
    });
  };

  openNewForm = () => {};

  getOnSelectOrgMisDetails = async (row) => {
    const info = await this.getInfo(row.AutoID);
    const roster = await this.getRoster(row.AutoID);
    const renewal = await this.getRenewal(row.AutoID);
    const workshop = await this.getWorkshop(row.AutoID);
    const riskmgt = await this.getRiskmgt(row.AutoID);
    const riskmgt2 = await this.getRiskmgt2(row.AutoID);
    const advisor = await this.getAdvisor(row.AutoID);
    const financialRisk = await this.getFinancialRisk(row.AutoID);

    return {
      info,
      roster,
      renewal,
      workshop,
      riskmgt,
      riskmgt2,
      advisor,
      financialRisk
    };
  };

  handleOnSelect = (row) => {
    this.getOnSelectOrgMisDetails(row).then((data) => {
      this.setState({
        orgName: row,
        info: data.info,
        roster: data.roster,
        renewal: data.renewal,
        workshop: data.workshop,
        riskmgt: data.riskmgt,
        riskmgt2: data.riskmgt2,
        advisor: data.advisor,
        financialRisk: data.financialRisk
      });
      this.toggle();
    });
  };

  getExport = (data) => {
    console.log("export 1");
    var date = new Date();
    var thisYear = date.getFullYear();
    var thisMonth = date.getMonth();

    let currentClassYearFirstYear = thisYear;

    if (thisMonth < 8) {
      currentClassYearFirstYear = thisYear - 1;
    }

    let headers = [];

    for (let i = 2017; i <= currentClassYearFirstYear; i++) {
      data.infos.forEach((element) => {
        let thisLoopYear = element.year;

        this.props.orgs.orgs.forEach((e) => {
          if (element.AutoID === e.AutoID && thisLoopYear == i) {
            e[`Info` + i] = "Yes";
          }
        });
      });
      headers.push({ label: `Info${i}`, key: `Info${i}` });

      data.renewals.forEach((element) => {
        let thisLoopYear = element.year;

        this.props.orgs.orgs.forEach((e) => {
          if (element.AutoID === e.AutoID && thisLoopYear == i) {
            e[`Renewals` + i] = "Yes";
          }
        });
      });
      headers.push({ label: `Renewals${i}`, key: `Renewals${i}` });

      data.workshops.forEach((element) => {
        let thisLoopYear = element.year;

        this.props.orgs.orgs.forEach((e) => {
          if (element.AutoID === e.AutoID && thisLoopYear == i) {
            e[`Workshops` + i] = "Yes";
          }
        });
      });
      headers.push({ label: `Workshops${i}`, key: `Workshops${i}` });

      data.advisors.forEach((element) => {
        let thisLoopYear = element.year;

        this.props.orgs.orgs.forEach((e) => {
          if (element.AutoID === e.AutoID && thisLoopYear == i) {
            e[`Advisors` + i] = "Yes";
          }
        });
      });
      headers.push({ label: `Advisors${i}`, key: `Advisors${i}` });
    }
    return headers;
  };

  getExport2 = (data) => {
    console.log("export 2");
    var date = new Date();
    var thisYear = date.getFullYear();
    var thisMonth = date.getMonth();
    let currentClassYearFirstYear = thisYear;

    let currentSemester = "";
    let headers = [];
    for (let i = 2017; i <= currentClassYearFirstYear; i++) {}
    if (thisMonth < 8) {
      currentSemester = "S";
    } else {
      currentSemester = "F";
    }
    for (let i = 2017; i <= thisYear; i++) {
      data.rosters.forEach((element) => {
        let thisLoopYear = element.year;
        let thisCount = element.members;
        this.props.orgs.orgs.forEach((e) => {
          if (element.AutoID === e.AutoID && thisLoopYear == i + "S") {
            e[`Rosters Spring` + i] = "Yes";
            e[`No. of Spring` + i + ` Members`] = thisCount;
          }
          if (element.AutoID === e.AutoID && thisLoopYear == i + "F") {
            e[`Rosters Fall` + i] = "Yes";
            e[`No. of Fall` + i + ` Members`] = thisCount;
          }
        });
      });
      if (currentSemester === "S") {
        headers.push({
          label: `Rosters Spring${i}`,
          key: `Rosters Spring${i}`,
        });
        headers.push({
          label: `No. of Spring${i} Members`,
          key: `No. of Spring${i} Members`,
        });
      } else {
        headers.push({
          label: `Rosters Fall${i}`,
          key: `Rosters Fall${i}`,
        });
        headers.push({
          label: `No. of Fall${i} Members`,
          key: `No. of Fall${i} Members`,
        });
      }
      data.riskmgts2.forEach((element) => {
        let thisLoopYear = element.year;
        this.props.orgs.orgs.forEach((e) => {
          if (element.AutoID === e.AutoID && thisLoopYear == i) {
            e[`Spring RiskMgt` + i] = "Yes";
          }
        });
      });
      headers.push({
        label: `Spring RiskMgt${i}`,
        key: `Spring RiskMgt${i}`,
      });
      data.riskmgts.forEach((element) => {
        let thisLoopYear = element.year;
        this.props.orgs.orgs.forEach((e) => {
          if (element.AutoID === e.AutoID && thisLoopYear == i) {
            e[`Fall RiskMgt` + i] = "Yes";
          }
        });
      });
      headers.push({
        label: `Fall RiskMgt${i}`,
        key: `Fall RiskMgt${i}`,
      });
    

     data.financialRisks.forEach((element) => {
        let thisLoopYear = element.year;
       this.props.orgs.orgs.forEach((e) => {
         if (element.AutoID === e.AutoID && thisLoopYear == i + "S") {
           e[`FinancialRisk Spring` + i] = "Yes";
       }
        if (element.AutoID === e.AutoID && thisLoopYear == i + "F") {
            e[`FinancialRisk Spring` + i] = "Yes";
       }
      });
     });

       if (currentSemester === "S") {
        headers.push({
         label: `FinancialRisk Spring${i}`,
          key: `FinancialRisk Spring${i}`,
        });
      } else {
        headers.push({
          label: `FinancialRisk Fall${i}`,
          key: `FinancialRisk Fall${i}`,
        });
  }}
    return headers;
  };

  
  render() {
    const { orgs } = this.props.orgs;

    const { username, isAdmin } = this.props.user[0];
    const columns = [
      {
        dataField: "Name",
        text: "Organization",
        filter: textFilter(),
        style: {
          color: "blue",
        },
      },
      {
        dataField: "Type",
        text: "Type    (Click to here sort)",
        sort: true,
      },
      {
        dataField: "Email",
        text: "Organization Email"
      },
      {
        dataField: "StudentContact",
        text: "President Name",
        filter: textFilter(),
      },
      {
        dataField: "StudentEmail",
        text: "Student Email",
      },
      { 
        dataField: "RosterManagerName", 
        text: "Roster Manager" 
      },
      { 
        dataField: "RosterManagerEmail", 
        text: "Roster Manager Email" 
      },
      { 
        dataField: "FinancialManagerName", 
        text: "Financial Manager" 
      },
      { 
        dataField: "FinancialManagerEmail", 
        text: "Financial Manager Email" 
      },
      {
        dataField: "Standing",
        text: "Standing   (Click to here sort)",
        sort: true,
      },
      {
        dataField: "Keywords",
        text: "Search Keywords",
        filter: textFilter(),
      }
    ];

    const rowEvents = {
      onClick: (e, row, rowIndex) => {
        this.handleOnSelect(row);
      },
    };

    let addNewModal = (
      <Modal
        isOpen={this.state.modalAddNew}
        toggle={this.toggleAddNew}
        style={{ maxWidth: "1600px", width: "80%" }}>
        <ModalBody>
          <Form>
            <FormGroup>
              {this.state.addNewId === "addNew" ? (
                <Fragment>
                  <AddNew
                    toggle={this.toggleAddNewClose}
                    getNewOrgsUpdate={this.props.getOrgs}
                  />
                </Fragment>
              ) : null}
            </FormGroup>
          </Form>
        </ModalBody>
      </Modal>
    );

    return (
      <div>
        <Button
          id="addNew"
          className="m-3"
          color="primary"
          onClick={this.toggleAddNew}>
          Add New
        </Button>
        <button
          className="btn btn-primary m-3"
          onClick={() => this.handleExport()}>
          Export
        </button>
        <CSVLink
          data={orgs}
          headers={this.state.headers}
          target="_blank"
          filename={"orgs.csv"}
          ref={(r) => (this.csvLink = r)}
        />
        {addNewModal}
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          style={{ maxWidth: "1600px", width: "80%" }}>
          <ModalBody>
            <Form>
              <FormGroup>
                {username && isAdmin === "Yes" ? (
                  <Fragment>
                    <OrgDetailsAdmin
                      orgName={this.state.orgName}
                      info={this.state.info}
                      roster={this.state.roster}
                      renewal={this.state.renewal}
                      workshop={this.state.workshop}
                      riskmgt={this.state.riskmgt}
                      riskmgt2={this.state.riskmgt2}
                      advisor={this.state.advisor}
                      financialRisk={this.state.financialRisk}
                      toggle={this.toggle}
                      getNewOrgsUpdate={this.props.getOrgs}
                    />
                  </Fragment>
                ) : (
                  <Fragment>
                    <OrgDetails
                      orgName={this.state.orgName}
                      info={this.state.info}
                      roster={this.state.roster}
                      renewal={this.state.renewal}
                      workshop={this.state.workshop}
                      riskmgt={this.state.riskmgt}
                      riskmgt2={this.state.riskmgt2}
                      advisor={this.state.advisor}
                      financialRisk={this.state.financialRisk}
                      toggle={this.toggle}
                      getNewOrgsUpdate={this.props.getOrgs}
                    />
                  </Fragment>
                )}
              </FormGroup>
            </Form>
          </ModalBody>
        </Modal>
        <BootstrapTable
          wrapperClasses="table-responsive ml-3"
          keyField="AutoID"
          data={orgs}
          columns={columns}
          pagination={paginationFactory()}
          filter={filterFactory()}
          rowEvents={rowEvents}
        />
      </div>
    );
  }
}

OrgsList.propTypes = {
  getOrgs: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  orgs: state.orgs,
  auth: state.auth,
});

export default connect(mapStateToProps, {
  getOrgs,
})(OrgsList);
